import { useState, useRef } from "react";
import "./style.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Grid, IconButton } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Zoom from "@mui/material/Zoom";
import Fade from "@mui/material/Fade";
import ZoomInIcon from "@mui/icons-material/ZoomIn";

const style = {
  position: "absolute",
  top: "20%",
  left: "33%",
  width: "27rem",
  "@media (min-width: 1636px)": {
    width: "33rem",
  },
  p: 1.5,
};

const ImageModal = (props) => {
  const ImgContainerRef = useRef(null);
  const classes = useStyles();

  let [visible, setVisible] = useState(false);

  return (
    <>
      <Fade in={true} timeout={500}>
        <img
          src={`${sessionStorage.getItem('media_url')}image/${props.src}`}
          className={props.width ? "" : "imageSize"}
          height={props.height}
          style={{ ...props.style, cursor: "pointer" }}
          onClick={() => {
            setVisible(true);
          }}
        />
      </Fade>
      <IconButton
        aria-label="delete"
        size="medium"
        onClick={() => {
          setVisible(true);
        }}
      >
        <ZoomInIcon fontSize="inherit" />
      </IconButton>

      <Modal
        open={visible}
        onClose={() => {
          setVisible(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
        ref={ImgContainerRef}
      >
        <Zoom in={visible}>
          <Box
            sx={{
              ...style,
              backgroundColor: "white",
              border: 0,
              borderRadius: 2,
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item sx={{ justifyContent: "center" }}>
                <Zoom timeout={500} in={true} mountOnEnter unmountOnExit>
                  <img
                    src={`${sessionStorage.getItem('media_url')}image/${props.src}`}
                    className={classes.image}
                  ></img>
                </Zoom>
              </Grid>
            </Grid>
          </Box>
        </Zoom>
      </Modal>
    </>
  );
};

const useStyles = makeStyles({
  image: {
    width: "26rem",
    borderRadius: 6,
    "@media (min-width: 1636px)": {
      width: "32rem",
    },
  },
});

export default ImageModal;
